import React from 'react';
import AdminLayout from '../../components/AdminLayout/AdminLayout';
import AdminDashboardWidgetPreviews from './Dashboard/AdminDashboardWidgetPreviews';

const AdminDashboard = () => {
  return (
    <AdminLayout>
      <AdminDashboardWidgetPreviews />
    </AdminLayout>
  );
};

export default AdminDashboard;
